/**
 * The QKey mark.
 *
 * QKEY_BRAND_GUIDELINES.md §2 defines a family of marks. This component serves
 * the ICON BADGE (§2a) — the circular indigo→violet gradient carrying a white Q
 * whose tail is a key — because that is the one that works as chrome:
 *
 *   · favicon.png IS that badge, and is byte-identical to the token mark.
 *   · qkey-padlock.png (§2b, the "QKEY PROTECTED" shield) is a glow render
 *     baked onto a BLACK field. On the near-black dark ground it disappears;
 *     on the paper ground it is a black tile. It is a certification badge for
 *     use on content, not a nav mark, and is not used here.
 *   · qkey-logo.svg (§2c) is a WORDMARK, not an icon — the nav sets its own
 *     wordmark in live text beside this mark, exactly as QSAVE's nav does, so
 *     the SVG's baked Inter-800 gradient text would be a second, conflicting
 *     wordmark at a different size.
 *
 * Served as an <img> rather than inlined: it is a raster asset with a gradient
 * and antialiased curves, so there is nothing to gain from inlining and a real
 * cache entry to lose. `alt=""` because every use site is inside a link that
 * already carries the accessible name — announcing it twice is noise.
 *
 * The guidelines' minimum digital size is 32px (favicon excepted). The nav uses
 * 34, the footer 20 — the footer is BELOW that floor and is deliberate: it
 * matches QSAVE's 20px footer mark, and it sits immediately beside a live-text
 * "QKEY" wordmark that carries the identity at that size. Do not read the 20
 * as licence to go smaller elsewhere.
 */
interface QkeyMarkProps {
  /** Rendered pixel size. Sets width/height attributes for layout stability. */
  size?: number
  className?: string
}

export function QkeyMark({ size = 34, className = '' }: QkeyMarkProps) {
  return (
    <img
      src="/favicon.png"
      alt=""
      width={size}
      height={size}
      className={`rounded-full ${className}`}
    />
  )
}
